var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 13.0001V11.077L9.2986 4.75146L11.2486 6.70181L4.92308 13.0001H3Z",
    fill: "#234596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6616 6.28672L9.71332 4.33847L10.8203 3.26644C10.9913 3.09441 11.2535 3 11.4965 3C11.7382 2.99937 11.97 3.09529 12.1406 3.26644L12.735 3.86085C12.9054 4.03121 13.0008 4.26253 13 4.5035C13 4.74826 12.9053 5.00875 12.7336 5.18043L11.6616 6.28672Z",
    fill: "#234596"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwKSI+CjxwYXRoIGQ9Ik0zIDEzLjAwMDFWMTEuMDc3TDkuMjk4NiA0Ljc1MTQ2TDExLjI0ODYgNi43MDE4MUw0LjkyMzA4IDEzLjAwMDFIM1oiIGZpbGw9IiMyMzQ1OTYiLz4KPHBhdGggZD0iTTExLjY2MTYgNi4yODY3Mkw5LjcxMzMyIDQuMzM4NDdMMTAuODIwMyAzLjI2NjQ0QzEwLjk5MTMgMy4wOTQ0MSAxMS4yNTM1IDMgMTEuNDk2NSAzQzExLjczODIgMi45OTkzNyAxMS45NyAzLjA5NTI5IDEyLjE0MDYgMy4yNjY0NEwxMi43MzUgMy44NjA4NUMxMi45MDU0IDQuMDMxMjEgMTMuMDAwOCA0LjI2MjUzIDEzIDQuNTAzNUMxMyA0Ljc0ODI2IDEyLjkwNTMgNS4wMDg3NSAxMi43MzM2IDUuMTgwNDNMMTEuNjYxNiA2LjI4NjcyWiIgZmlsbD0iIzIzNDU5NiIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwIj4KPHJlY3Qgd2lkdGg9IjEwIiBoZWlnaHQ9IjEwIiBmaWxsPSJ3aGl0ZSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMyAzKSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };